import React from "react";
import Layout from "../components/layout";
import Seo from "../components/head";
import ProjectsPageContent from "../components/projects/projects-page";

const ProjectsPage = () => {
  return (
    <Layout>
      <ProjectsPageContent />
    </Layout>
  );
};

export default ProjectsPage;

export const Head = () => <Seo title="Projects" />;